import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest';
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax';
import Password from 'schemas/Password';

export default DataRequest({
  schema: Password,

  perform(bridgeRefreshToken, oldPassword, newPassword) {
    return ajax({
      url: "/api/learner/profile/password",
      data: {
        current_password: oldPassword,
        new_password: newPassword,
        refresh_token: bridgeRefreshToken
      },
      dataType: "json",
      method: "PUT"
    });
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/shared/data_requests/changePassword.js